import stbAPIGateway from '../../../../services/stbAPIGateway';

export const patchCsvZipHubUploadBatchStatus = async (
  { rootGetters },
  { clientSid, batchId, status }
) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const response = await stbApi.patchCsvZipHubUploadBatchStatus({}, clientSid, batchId, status);
  return response;
};
